export default __webpack_public_path__ + "static/1-67e4d3ac818177694feee3a0a000b496.png";